import _ from 'underscore';
import Backbone from 'backbone';
import { state } from '../state-manager/state-model';
import { ExcessMoneyView } from './excess-money/excess-money-view';

import tpl from './user-info-template.ejs';

export var UserInfoView = Backbone.View.extend({
  el: '.app__user-info',

  template: tpl,

  initialize: function () {
    this.on('refresh', this.refresh, this);
    this.listenTo(this.model, 'change', this.render);

    _.bindAll(this, 'render');
  },

  events: {
    'click [data-role=toggleMyBalance]': 'toggleMyBalance',
    'click [data-role=showExcessMoney]': 'showExcessMoney'
  },

  render: function () {
    this.$el.html(this.template(this.model.attributes));

    return this;
  },

  refresh: function () {
    this.model.fetch({ game: state.get('game') });
  },

  toggleMyBalance: function (e) {
    e.preventDefault();
    this.$el.find('[data-role=myBalance]').toggle();
  },

  showExcessMoney: function (e) {
    e.preventDefault();

    var excessView = new ExcessMoneyView({ model: this.model });
    excessView.render();
  }
});
